var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class SchemaUIRow {
    constructor(vis = false, entries = []) {
        this.rowindex = -1;
        this.uirowindex = -1;
        this.rowid = "";
        this.childrenschemalist = [];
        this.entry = [];
        this.hidden = false;
        this.objsdec = [];
        this.shsdec = [];
        this.linkedids = [];
        this.referenceids = [];
        makeObservable(this);
        this.hidden = vis;
        this.entry = entries;
    }
    setVisibility(vis) {
        this.hidden = vis;
    }
    addEntries(entries) {
        this.entry = entries;
    }
    updateEntries(entries) {
        let newen = [];
        let newenmap = new Map();
        for (const ne of entries) {
            newenmap.set(ne.cellid, ne);
        }
        newen.push(...entries);
        for (const en of this.entry) {
            if (!newenmap.has(en.cellid)) {
                newen.push(en);
            }
        }
        this.entry = newen;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaUIRow.prototype, "entry", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaUIRow.prototype, "hidden", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaUIRow.prototype, "setVisibility", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaUIRow.prototype, "addEntries", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaUIRow.prototype, "updateEntries", null);
